import React, { useState, useRef, useCallback } from 'react';
// Removed axios, AntD Button, AntD Spin imports as handleSubmit is moved to parent
// Removed status prop setters as they are managed by the parent

function DragAndDropInput({
    allowedFileNames,
    onFileSelected, // RECEIVE onFileSelected PROP
    // Removed onFileUploadSuccess, setUploadStatus, setPythonStatus, setDatabaseStatus, setProcessStatus, setPythonResponse, setNodeResponse, setDatabaseResponse, setReportMetrics, setSuccessMessage, setCurrentFileName, setUploading, onFileUploadStart, uploadCompleted, resetUploadCompleted, onProcessStepChange as handleSubmit is moved
}) {
    const [errorMessage, setErrorMessage] = useState('');

    const dragAreaRef = useRef(null);
    const fileInputRef = useRef(null);
    const allowedFileTypes = ['xlsx', 'xls', 'pdf'];

    const handleDragOver = (event) => {
        event.preventDefault();
        if (dragAreaRef.current) {
            dragAreaRef.current.classList.add('drag-over');
        }
    };

    const handleDragLeave = (event) => {
        event.preventDefault();
        if (dragAreaRef.current) {
            dragAreaRef.current.classList.remove('drag-over');
        }
    };

    const handleDrop = (event) => {
        event.preventDefault();
        if (dragAreaRef.current) {
            dragAreaRef.current.classList.remove('drag-over');
        }

        const files = event.dataTransfer.files;
        if (files && files.length > 0) {
            handleFileChange(files[0]);
        }
    };

    const handleFileInputChange = (event) => {
        const files = event.target.files;
        if (files && files.length > 0) {
            handleFileChange(files[0]);
        }
        // Clear the file input value after selecting a file
        if (fileInputRef.current) {
             fileInputRef.current.value = '';
        }
    };

    // Use useCallback for handleFileChange as it's passed to event handlers
    const handleFileChange = useCallback((file) => {
        console.log("handleFileChange called with file:", file);
        setErrorMessage('');

        if (!file) {
            console.log("No file selected or file is null in handleFileChange");
            return;
        }

        const fileExtension = file.name.split('.').pop().toLowerCase();
        if (!allowedFileTypes.includes(fileExtension)) {
            setErrorMessage(`Tipo de archivo no permitido. Solo se aceptan archivos ${allowedFileTypes.join(', ')}`);
            console.log("Invalid file type in handleFileChange");
            return;
        }

        const uploadedFileName = file.name;
        if (allowedFileNames !== null && !allowedFileNames.includes(uploadedFileName)) {
            setErrorMessage(`Archivo no válido. Debe cargar un archivo con un nombre válido de su lista de Marcas.`);
            console.log("Invalid file name in handleFileChange");
            return;
        }

        // If file is valid, call the parent handler
        if (onFileSelected) {
            onFileSelected(file);
        }

    }, [allowedFileNames, allowedFileTypes, onFileSelected]); // Added dependencies


    const triggerFileInput = (event) => {
        event.stopPropagation();
        fileInputRef.current.click();
    };


    return (
        
            
                <div className="drag-and-drop-container">
                    <div
                        ref={dragAreaRef}
                        className="drag-area"
                        onDragOver={handleDragOver}
                        onDragEnter={handleDragOver}
                        onDragLeave={handleDragLeave}
                        onDrop={handleDrop}
                    >
                        <p style={{fontSize: 'large'}}>Arrastre y suelte aquí su nueva lista de precios</p>
                        <p>ó</p>
                        <button type="button" onClick={triggerFileInput} style={{fontSize: 'large'}}>Buscar Archivo</button>
                    </div>
                    <input
                        type="file"
                        accept=".xlsx, .xls, .pdf"
                        style={{ display: 'none' }}
                        onChange={handleFileInputChange}
                        ref={fileInputRef}
                    />

                    {errorMessage && <p className="error-message">{errorMessage}</p>}

                </div>
            
        
    );
}

export default DragAndDropInput;